/** Web has no over-the-air updates, so the splash is never held for one. */
export function useStartupUpdateGate(): boolean {
  return true;
}
